module.exports = __webpack_public_path__ + "static/img/icon-bargain.5107d1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bargain/icon-bargain.png
// module id = e5yd
// module chunks = 1